export const updatePosition = (lat, lng, map) => {
  map.panTo({lat: lat, lng: lng});
  map.panBy(0, -200);
};
